import React, { useMemo, useEffect, Fragment } from 'react';

export default (props: {
  selectNameText?: string;
  options: Array<string>;
  selectLen: number;
  showNumber?: number;
  formatMessage: (value: any) => any;
  buttonItemRender?: (value: any) => string | React.ReactNode;
  basicOptionsMap: { [key: string]: string };
}) => {
  const {
    selectNameText = '',
    options,
    selectLen,
    showNumber = 2,
    formatMessage,
    buttonItemRender,
    basicOptionsMap,
  } = props;

  const render = useMemo(() => {
    let text = <span className="select-button-text">{selectNameText}</span>;
    let showElement: string | number | Array<JSX.Element> = selectLen;
    let isAll = false;
    // 没有数据，显示None
    if (options.length === 0) {
      showElement = formatMessage({ id: 'None' });
    }
    // 选中的和选项一样多，就是ALL
    else if (options.length === selectLen) {
      showElement = formatMessage({ id: 'All' });
      isAll = true;
    }
    // 如果是大于0 并小于showNumber项就显示单项内容
    else if (options.length <= showNumber) {
      let len = options?.length - 1;
      showElement = options?.map((item: string, i: number) => {
        return (
          <Fragment key={item}>
            {buttonItemRender ? buttonItemRender(item) : basicOptionsMap[item]}
            {len !== i ? <span className="db-select-button-gap">, </span> : ''}
          </Fragment>
        );
      });
    } else {
      showElement = options.length;
    }
    return (
      <>
        {text} <span className="select-button-value">{showElement}</span>
      </>
    );
  }, [options, formatMessage, selectNameText]);

  return <div className="db-group-multiselect-button-wrap">{render}</div>;
};
